import dayjs from "utils/dates/dayjsex";

export const DEFAULT_AUCTION_DURATION = dayjs.duration(24, "hours");
export const DEFAULT_TIME_EXTENSION_DURATION = dayjs.duration(5, "minutes");
